import aad from "../assets/achievement/aad.png";
import bangkit from "../assets/achievement/bangkit-cert.jpeg";
import pim from "../assets/achievement/pim-cert.jpeg";

let achivements = [
  {
    id: "01",
    title: "Google Certified Android Associate Developer",
    by: "Google",
    date: "2021",
    imageUrl: "../assets/achievement/aad1.png",
    additionalImage: aad,
    description: (
      <p>
        I have obtained the Android Application Development (AAD) Certification,
        showcasing my knowledge and skills in designing, developing, and
        implementing innovative Android applications. With a deep understanding
        of the Android SDK, Java or Kotlin programming languages, and principles
        of UI/UX design, I possess the ability to create appealing and
        responsive user interfaces. Additionally, I have hands-on experience in
        various Android application development projects, including feature
        development, API integration, testing, and troubleshooting. My expertise
        extends to ensuring security and optimizing performance in Android
        applications, coupled with strong teamwork and collaboration skills in
        multidisciplinary development environments.
      </p>
    ),
  },
  {
    id: "02",
    title: "Distinction Graduated at Bangkit Academy 2022",
    by: "Google, GoTo, Traveloka",
    date: "2021",
    imageUrl: "../assets/achievement/bangkit.png",
    additionalImage: bangkit,
    description: (
      <p>
        After a great 6 months journey of learning Android Development at
        Bangkit Academy led by Google, Tokopedia, Gojek, & Traveloka. Finally I
        Graduate with Distinction! It was a great experience to be a part for
        this wonderful program. The journey that I took while studying in this
        program was not easy, but I am proud to have passed all these challenges
        with satisfactory results. That was a lot of work but it definitely paid
        off. I also successful to pass the Google Certified Associate Android
        Developer.
        <br />
        Special thanks to Bangkit Team , my facilitator Ghani Rasyid Hika and my
        capstone team Waras Aprillia Anggera, Alfendio Alif Faudisyah, Kartika
        Okta, Alextonio Winatian, and melina azzahra.
      </p>
    ),
  },
  {
    id: "03",
    title: "Academic Achievement Scholarship",
    by: "Satya Wacana Christian University",
    date: "2020 - 2023",
    imageUrl: "../assets/achievement/uksw.jpg",
    additionalImage: "",
    description: (
      <p>
        Currently receive Academic Achievement Scholarship at Satya Wacana
        Christian University
      </p>
    ),
  },
  {
    id: "04",
    title: "Champion of Programming Contest at GEMASTIK 2022",
    by: "Satya Wacana Christian University",
    date: "2022",
    imageUrl: "../assets/achievement/gemastik.jpg",
    additionalImage: pim,
    description: (
      <p>
        Champion of Programming Contest with my Team. We Build Academic System
        using PHP Native
      </p>
    ),
  },
];

export default achivements;
